import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostBewertungsAnlassCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostBewertungsAnlassCommandService],
  exports: []
})
export class PostBewertungsAnlassCommandServiceModule { }
